import {types} from '../../types';

const setGetUsersListAction = (payload) => {
    return {
        type: types.users.SET_SEARCH_USERS_LIST,
        payload,
      }
}

export {
  setGetUsersListAction as SetGetUsersListAction
}
